<template>
	<div class="dashboard-container" v-bind:class="{navBarVisibility: navBarVisibility}">
		<div class="nav-bar" v-show="navBarVisibility">
			<TheNavBar @toggleNavBar="expandNavBar" :title="pageTitle" :assignUserStatus="assignUserStatus" :navBarVisibility="navBarVisibility" />
		</div>
		<a href="#" class="nav-bar-button" @click.prevent="expandNavBar">Expand</a>
		<div class="content">
			<TheDashboardHeader :title="pageTitle" @toggleNavBar="expandNavBar" :assignUserStatus="assignUserStatus" :navBarVisibility="navBarVisibility" />
			<transition name="fade" mode="out-in">
				<router-view @test="test" />
			</transition>
			<TheDashboardFooter/>
		</div>
	</div>
</template>

<script>
import TheDashboardHeader from '@/components/basic/TheDashboardHeader'
import TheNavBar from '@/components/basic/TheNavBar'
import TheDashboardFooter from '@/components/basic/TheDashboardFooter'

export default {
	name: 'dashboard',
	data() {
		return {
			pageTitle: '',
			navBarVisibility: false,
			assignUserStatus: false
		}
	},
	components: {
		TheDashboardHeader,
		TheNavBar,
		TheDashboardFooter,
	},
	mounted() {
		this.pageTitle = this.$route.name
	},
	beforeUpdate() {
		this.pageTitle = this.$route.name
	},
	methods: {
		expandNavBar() {
			this.navBarVisibility = !this.navBarVisibility;
		},
		navBarVisibilityStatus() {
			if (window.innerWidth > 767)
				this.navBarVisibility = true;
			else if (window.innerWidth < 767)
				this.navBarVisibility = false
		},
		test(status) {
			this.assignUserStatus = status;
		}
	}
}
</script>

<style lang="scss" scoped>

.dashboard-container {

	display: flex;
	flex-direction: row;
	position: relative;

	.nav-bar-button {

		position: absolute;
		top: 30px;
		left: 20px;
		z-index: 999;
		@media (min-width: 767px) {
			display: none;
		}

		&:hover {
			@media (max-width: 767px) {
				color: #404E6E;
			}
			color: white;
		}
	}

	.nav-bar {
		padding: 25px 0 10px 45px;
		box-shadow: -2px 2px 16px 0px #c1b6b6;
		background-color: white;
		flex: 0 1 25%;
		max-width: 25%;
		@media (max-width: 767px) {
			position: absolute;
			z-index: 999;
			display: block;
			width: 75%;
			height: 100vh;
			flex: 0 1 75%;
			max-width: 75%;
		}
	}

	&.navBarVisibility {
		.nav-bar-button {
			left: 180px;
			color: #35495e;
		}
	}

	.content {
		position: relative;
		background-color: #c0ced7;
		flex: 0 1 100%;
		max-width: 100%;
	}

}

.fade-enter-active, .fade-leave-active {

	transition: opacity .2s;
	opacity: 1;
}

.fade-enter, .fade-leave-to {

	opacity: 0;
}

</style>
